module.exports = __webpack_public_path__ + "static/video-20570f8b2391f23225d5084be492633f.png";